import { Box } from "@material-ui/core";

import { Map } from "../../../../../components/map";

export const AssetDetailMap = ({ building }) => {
  return (
    <>
      <Box sx={{ pb: 2 }}>
        <Map height="220px" properties={[building]} />
      </Box>
    </>
  );
};
